import script from "./CSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./CSelect.vue?vue&type=script&setup=true&lang=ts"

import "./CSelect.vue?vue&type=style&index=0&id=76265f36&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76265f36"]])

export default __exports__